<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="order !== null">

    <div class="p-grid">
      <div class="p-col-6">
        <h2>{{ t('common.labels.todos') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true && inOrdering !== true">
        <button *ngIf="order?.todos?.length > 0" withRight="admin.planning-orders.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
        </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true || inOrdering === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <p-table
      [value]="todos"
    >

      <ng-template pTemplate="colgroup">
        <colgroup>
            <col style="width:45%">
            <col style="width:10%">
            <col style="width:45%">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th>{{ t('common.labels.todo') }}</th>
          <th>{{ t('common.labels.completed') }}</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-todo>
        <tr tabindex="0">
          <td>{{ todo.viewName }}</td>
          <td>
            <app-form-control [cid]="'completed' + todo.id" [control]="todo.control" [type]="'checkbox'" [edit]="inEdit" [basevalue]="todo.completed" [noMargin]="true" [showLabel]="false"></app-form-control>
          </td>
          <td>
            <ng-container *ngIf="todo.completed === true">
              {{ todo.completed_at | amLocal | amDateFormat: 'DD.MM.YYYY HH:mm' }} {{ t('common.labels.oclock') }} / {{ todo.completed_by.firstname }} {{ todo.completed_by.lastname }}
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="5">{{ t('common.labels.no_todos') }}</td>
        </tr>
      </ng-template>

    </p-table>

  </form>
</ng-container>
